var _ = require('underscore/underscore.js');
var Base = require('front/components/Base/Base');

var template = require('./CommonHonoredList.jinja');
require('./CommonHonoredList.less');

var CommonHonoredListInner = require('front/components/CommonHonoredList/CommonHonoredListInner');

var CommonHonoredListTemplate = require('front/components/CommonHonoredList/CommonHonoredListInnerRuntime.jinja');

var objectFitImages = require('object-fit-images');

module.exports = Base.extend({

    template: template,

    events: {
        'click .CommonHonoredList-showMoreButton': 'onClickMoreButton'
    },

    moreApi: function () {
        return this.state.next;
    },

    //Base creates an instances for each one of found dom nodes (by selector) when parent view is rendered itself
    VIEWS_TO_REGISTER: {
        'CommonHonoredListInner': {selector: '.CommonHonoredListInner', viewConstructor: CommonHonoredListInner}
    },


    initialize: function (options) {
        this.options = options || {};

        _.bindAll(this, 'moreApi');

        this.state = {
            next: undefined,
            hasMore: false
        };

        Base.prototype.initialize.call(this, options);
    },


    activate: function () {

        return Base.prototype.activate.call(this);
    },


    viewsRegistration: function () {
        Base.prototype.viewsRegistration.call(this);

    },


    destroy: function () {

        return Base.prototype.destroy.call(this);
    },

    onClickMoreButton: function (e) {
        var self = this;
        this.$('.CommonHonoredList-showMoreButton').addClass('Button--loading');
        this.category = $(e.currentTarget).data('category');
        this.id = $(e.currentTarget).data('id');

        if (this.state.next === undefined) {
            this.state.next = Urls['front:api:awards_honored_list']
                .apply(this, (!!this.id ? [this.category, this.id] : [this.category]).concat(['json']))
                + '?offset=' + this.$('.CommonHonoredListInner-person').size();
        }

        this.forceLoadData(this.moreApi)
            .then(function () {
                self.state.next = self.data.next;
                var $articles = $(CommonHonoredListTemplate.render({data: self.data.results}));
                self.state.hasMore = !!self.data.next;

                self.$('.CommonHonoredList-items').append($articles);

                self.$('.CommonHonoredList-showMoreButton')
                    .toggle(!!self.state.hasMore)
                    .removeClass('Button--loading');

                app.animateShowMoreSlideDown({$items: $articles});

                new CommonHonoredListInner({
                    el: $articles[0]
                });

                window.app.utils.updateLinksAttributes(self.$('.CommonHonoredList-items'));

                objectFitImages();
            });
    }
});



//////////////////
// WEBPACK FOOTER
// ./assets/app/front/components/CommonHonoredList/CommonHonoredList.js
// module id = 64
// module chunks = 0